document.addEventListener('DOMContentLoaded', function() {
  // Handle design gallery "Add to Design Studio" button clicks
  const designStudioButtons = document.querySelectorAll(
    '.design-studio-add-design-button'
  );

  designStudioButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const designId = this.getAttribute('data-design-id');
      const designUrl = this.getAttribute('data-design-url');

      const designData = {
        id: designId,
        url: designUrl,
        fromGallery: true,
      };

      // Check if this is the first design/product being added
      const storedFormData = localStorage.getItem('formData');
      let isFirstItem = true;
      if (storedFormData) {
        try {
          const formData = JSON.parse(storedFormData);
          isFirstItem = !formData.design && !formData.product;
        } catch (e) {}
      }

      // Store the design in localStorage for backward compatibility
      const currentFormData = storedFormData
        ? JSON.parse(storedFormData)
        : { isStudent: true, school: 'Other' };

      // Ensure designCustomization exists
      if (!currentFormData.designCustomization) {
        currentFormData.designCustomization = {
          sideDesigns: { front: [], side: [], back: [] },
          designPool: [],
          sideColorMappings: {},
          positions: {},
          sizes: {},
        };
      }

      // Always ensure new designs go to pool by clearing any existing placements
      if (currentFormData.designCustomization) {
        // Clear this design from all sides
        if (currentFormData.designCustomization.sideDesigns) {
          Object.keys(currentFormData.designCustomization.sideDesigns).forEach(
            side => {
              if (
                Array.isArray(
                  currentFormData.designCustomization.sideDesigns[side]
                )
              ) {
                currentFormData.designCustomization.sideDesigns[
                  side
                ] = currentFormData.designCustomization.sideDesigns[
                  side
                ].filter(d => String(d.id) !== String(designId));
              }
            }
          );
        }

        // Ensure design pool exists
        if (!currentFormData.designCustomization.designPool) {
          currentFormData.designCustomization.designPool = [];
        }

        // Check if design is already in pool
        const inPool = currentFormData.designCustomization.designPool.some(
          d => String(d.id) === String(designId)
        );
        if (!inPool) {
          currentFormData.designCustomization.designPool.push({
            id: designId,
            url: designUrl,
            thumbnailUrl: designUrl,
            artCode: `Design ${designId}`,
            designUrl: designUrl,
          });
        }
      }

      currentFormData.design = {
        id: designId,
        url: designUrl,
        artCode: `Design ${designId}`,
        designUrl: designUrl,
      };
      localStorage.setItem('formData', JSON.stringify(currentFormData));

      // Dispatch event to notify OrderWizard
      const event = new CustomEvent('LoadDesignFromGallery', {
        detail: {
          ...designData,
          openModal: isFirstItem,
        },
      });
      window.dispatchEvent(event);

      // Force reload to ensure OrderWizard picks up changes
      window.dispatchEvent(new Event('storage'));

      // Update button text to indicate design was added
      this.textContent = 'Added to Design Studio';
      this.disabled = true;

      // Re-enable after a short delay
      setTimeout(() => {
        this.textContent = 'Update in Design Studio';
        this.disabled = false;
      }, 2000);
    });
  });
});
